import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui";
import { BrandLogoMark } from "@/brand";

export function NotFound() {
  const { t } = useTranslation("common");
  return (
    <div className="grid min-h-dvh place-items-center bg-bg p-6 text-center text-fg">
      <div>
        <div className="mx-auto mb-3 grid h-10 w-10 place-items-center rounded-lg bg-primary text-primary-fg">
          <BrandLogoMark className="h-6 w-6" />
        </div>
        <div className="font-display text-6xl font-bold text-primary">404</div>
        <h1 className="mt-2 font-display text-xl font-bold">{t("notFound.title")}</h1>
        <p className="mt-1 text-sm text-fg-muted">{t("notFound.body")}</p>
        <div className="mt-5">
          <Button onClick={() => window.location.assign("/")}>{t("notFound.backToMarkets")}</Button>
        </div>
      </div>
    </div>
  );
}
